export default __webpack_public_path__ + "static/media/like.a3110923.svg";